import { render, staticRenderFns } from "./DetailUser.vue?vue&type=template&id=56a253c7&scoped=true"
import script from "./DetailUser.vue?vue&type=script&lang=js"
export * from "./DetailUser.vue?vue&type=script&lang=js"
import style0 from "./DetailUser.vue?vue&type=style&index=0&id=56a253c7&prod&lang=scss&scoped=true"
import style1 from "./DetailUser.vue?vue&type=style&index=1&id=56a253c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a253c7",
  null
  
)

export default component.exports